module.exports = __webpack_public_path__ + "images/Type_C-35bc0a.png";